import { render } from "./openorders.vue?vue&type=template&id=d2a5d758"
import script from "./openorders.vue?vue&type=script&lang=js"
export * from "./openorders.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tommygrimm/PhpstormProjects/holcimportal.20north.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__